<template>
  <div class="col-4 col-sm-4 col-md-3 col-lg-2" :key="'training-' + training.id">
    <img :src="training.attributes.image_url" class="responsive"/>
    <span class="highlight">{{ training.attributes.name }}</span>
    <br/>
    <span class="grey--text" v-html="repsVal()"></span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  // props: ['training','planTraining', 'tr'],
  props: ['planTraining', 'plan'],
  computed: {
    training() {
      return this.$store.getters.getTraining( this.planTraining.relationships.training.data )
    },
    ...mapGetters(["currentUser"])
  },
  methods: {
    getTraining(that) {
      return this.$store.getters.getTraining(that)
    },
    repsVal() {
      let reps = "Max &times;"
      if ( this.planTraining.attributes.do_time ) { 
        reps = this.planTraining.attributes.do_time + " Sek." 
      } else if ( this.planTraining.attributes.do_reps ) { 
        reps = this.planTraining.attributes.do_reps + " &times;"
      } else if ( this.plan.attributes.each_time ) {
        reps = this.plan.attributes.each_time + " Sek." 
      } else if ( this.plan.attributes.each_reps ) {
        reps = this.plan.attributes.each_reps + " &times;"
      } else if ( this.plan.attributes['level_' + this.currentUser.level + '_reps'] ) {
        reps = this.plan.attributes['level_' + this.currentUser.level + '_reps'] + " &times;"
      }
      return reps
    }
  }
}
</script>

<style lang="scss">
.highlight {
  font-family: 'Shadows Into Light', cursive;
  // font-size: 120%;
  // text-shadow: 0 1px 1px #fff;
}
</style>